import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "confirmation-page__loading"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 2,
  class: "confirmation-page__error"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["href"]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = ["href"]

import {
	onMounted, computed, ref, Ref,
} from 'vue';
import { ShoppingCart } from '@/interfaces/checkout/shopping-cart';
import { getParam } from '@services/url';
import * as finishService from '@services/checkout/finishService';
import * as shoppingCartService from '@services/checkout/shoppingCartService';
import axios from 'axios';
import Loading from '@lmt-rpb/Loading/Loading.vue';
import CheckoutThankYou from '@lmt-rpb/CheckoutThankYou/CheckoutThankYou.vue';
import { useStore } from '@/components/common/store';
import AddPaymentInfo from '@/js/modules/analytics/AddPaymentInfo';
import { scrollIt } from '@utils/utils';
import { determineClient } from '@utils/environmentUtils';
import * as checkoutStorageService from '@services/localStorage/checkoutStorageService';

interface RequestData {
	Token: string;

	PaymentStatus: 'OK' | 'ERROR';

	BookingTest?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ConfirmationPage',
  setup(__props) {

const store = useStore();

const client = determineClient(window.location.href);

const shoppingCartResponse: Ref<ShoppingCart | undefined> = ref();

const shoppingCartRequestPending = ref(true);

const finishRequestPending = ref(false);

const tokenExpired = ref(false);

const unknownError = ref(false);

const phoneNumber = computed((): string => store.state.config.phone);

const phoneLink = computed((): string => 'tel:' + store.state.config.phoneLink);

const isBookingTest = ref(getParam('bookingtest') === '1');

onMounted(() => {
	init();
});

const preventTabClosingHandler = (e: BeforeUnloadEvent) => {
	e.preventDefault();
	e.returnValue = true;
};

async function init() {
	scrollIt(document.body);
	document.body.style.pointerEvents = 'none';
	document.body.style.overflow = 'hidden';
	try {
		await setShoppingCart();
	} catch (error) {
		if (error instanceof Error && error.message === 'Expired Token') {
			tokenExpired.value = true;
		} else if (axios.isAxiosError(error) && !axios.isCancel(error)) {
			unknownError.value = true;
		} else {
			unknownError.value = true;
		}
		console.error('Shopping Cart error:', {
			'Error Shopping Cart': JSON.stringify(error),
			'Shopping Cart Response': JSON.stringify(shoppingCartResponse.value),
			'Shopping Cart Token': getParam('token')
		});
	} finally {
		shoppingCartRequestPending.value = false;
		document.body.style.pointerEvents = 'auto';
		document.body.style.overflow = 'auto';
	}
}

async function setShoppingCart() {
	const token = getParam('token');
	const status = getParam('status') === 'error' ? 'ERROR' : 'OK';
	const requestData = getRequestData(token, status);
	shoppingCartResponse.value = await shoppingCartService.get(requestData.Token, false);
	await finishPurchase(shoppingCartResponse.value!.ShoppingCartID, requestData);
}

async function finishPurchase(id: string, requestData: RequestData) {
	const paymentDoneEntry = checkoutStorageService.getById(id);
	if (paymentDoneEntry?.status === 'payment' || paymentDoneEntry?.status === 'payed') {
		finishRequestPending.value = true;
		window.addEventListener('beforeunload', preventTabClosingHandler);
		checkoutStorageService.updateStatusById(shoppingCartResponse.value!.ShoppingCartID, 'finished');
		shoppingCartResponse.value = await finishService.get(requestData);
		window.removeEventListener('beforeunload', preventTabClosingHandler);
		finishRequestPending.value = false;
		sendGa4EventAddPaymentInfo(shoppingCartResponse.value);
	}
}

function getRequestData(token: string | null, status: 'OK' | 'ERROR') {
	if (!token || token.length < 10) {
		// eg token=error
		throw new Error('Token Invalid');
	}
	const requestData: RequestData = {
		Token: token,
		PaymentStatus: status,
	};
	if (isBookingTest.value) {
		requestData.BookingTest = isBookingTest.value;
	}
	return requestData;
}

function sendGa4EventAddPaymentInfo(shoppingCart: ShoppingCart | undefined) {
	if (shoppingCart) {
		const { Amount: amount, Currency: currency } = shoppingCart.Pricing.Total;
		const paymentType = shoppingCart?.PaymentType || '';
		const checkoutAnalytics = AddPaymentInfo.createInstance(currency, amount, paymentType, shoppingCart);
		checkoutAnalytics.fireBeginCheckoutDomReady();
	} else {
		console.error('Shooping Cart is not available.');
	}
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass([{'confirmation-page__loading-background': (finishRequestPending.value || shoppingCartRequestPending.value) && !tokenExpired.value && !unknownError.value} , "confirmation-page"])
  }, [
    (!shoppingCartRequestPending.value && !unknownError.value && !tokenExpired.value && shoppingCartResponse.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(CheckoutThankYou, {
            "shopping-cart": shoppingCartResponse.value,
            client: _unref(client)
          }, null, 8 /* PROPS */, ["shopping-cart", "client"])
        ]))
      : (!tokenExpired.value && !unknownError.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (finishRequestPending.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_3, " Ihre Buchung ist in Bearbeitung, bitte Fenster nicht schließen. "))
              : (_openBlock(), _createElementBlock("p", _hoisted_4, " Ihre Buchung wird abgefragt. Bitte Fenster nicht schließen. ")),
            _createVNode(Loading, { class: "confirmation-page__loading-spinner" })
          ]))
        : _createCommentVNode("v-if", true),
    (!shoppingCartRequestPending.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (tokenExpired.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _cache[2] || (_cache[2] = _createElementVNode("h1", null, "Bestätigungsseite abgelaufen", -1 /* HOISTED */)),
                _createElementVNode("p", null, [
                  _cache[0] || (_cache[0] = _createTextVNode("Lieber Kunde, die Details zu Ihrer Buchung können nicht mehr eingesehen werden. Die Buchungsbestätigung wurde Ihnen bereits an Ihre Email gesendet. Für weitere Fragen steht Ihnen unser Servicecenter unter ")),
                  _createElementVNode("a", { href: phoneLink.value }, _toDisplayString(phoneNumber.value), 9 /* TEXT, PROPS */, _hoisted_7),
                  _cache[1] || (_cache[1] = _createTextVNode(" zur Verfügung."))
                ]),
                _cache[3] || (_cache[3] = _createElementVNode("p", null, [
                  _createElementVNode("a", { href: "/suche" }, "Zurück zur Suche")
                ], -1 /* HOISTED */))
              ]))
            : _createCommentVNode("v-if", true),
          (unknownError.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _cache[6] || (_cache[6] = _createElementVNode("h1", null, "Es ist ein Fehler aufgetreten!", -1 /* HOISTED */)),
                _createElementVNode("p", null, [
                  _cache[4] || (_cache[4] = _createTextVNode("Lieber Kunde, bei Ihrer Buchung ist ein Fehler aufgetreten. Bitte prüfen Sie ob Sie eine Auftragsbestätigung per E-Mail erhalten haben, dies kann bis zu 15 Minuten dauern. Sollten Sie keine E-Mail erhalten haben, kontaktieren Sie uns bitte unter ")),
                  _createElementVNode("a", { href: phoneLink.value }, _toDisplayString(phoneNumber.value), 9 /* TEXT, PROPS */, _hoisted_9),
                  _cache[5] || (_cache[5] = _createTextVNode("."))
                ]),
                _cache[7] || (_cache[7] = _createElementVNode("p", null, [
                  _createElementVNode("a", { href: "/suche" }, "Zurück zur Suche")
                ], -1 /* HOISTED */))
              ]))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}
}

})